import { render, staticRenderFns } from "./StickyButtonsWrapper.vue?vue&type=template&id=65cfa604"
import script from "./StickyButtonsWrapper.vue?vue&type=script&lang=js"
export * from "./StickyButtonsWrapper.vue?vue&type=script&lang=js"
import style0 from "./StickyButtonsWrapper.vue?vue&type=style&index=0&id=65cfa604&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports